{
  "name": "idp-react",
  "version": "3.0.59",
  "private": true,
  "dependencies": {
    "@bugsnag/js": "^6.3.0",
    "@bugsnag/plugin-react": "^6.2.0",
    "@fortawesome/fontawesome-svg-core": "^6.4.0",
    "@fortawesome/free-regular-svg-icons": "^6.4.0",
    "@fortawesome/free-solid-svg-icons": "^6.4.0",
    "@fortawesome/react-fontawesome": "^0.2.0",
    "@reduxjs/toolkit": "^1.9.5",
    "baseline-browser-mapping": "2.11.25",
    "browserslist": "4.29.0",
    "crypto-js": "^4.2.0",
    "i18n-postal-address": "^0.7.0",
    "js-yaml": "3.15.2",
    "leaflet": "^1.9.4",
    "lodash": "^4.17.21",
    "moment": "2.31.0",
    "moment-business": "^3.0.1",
    "nanoid": "3.3.18",
    "react": "^18.2.0",
    "react-cropper": "^2.3.3",
    "react-dom": "^18.2.0",
    "react-ga": "^3.3.0",
    "react-gtm-module": "^2.0.11",
    "react-helmet": "^6.1.0",
    "react-redux": "^7.2.1",
    "react-router-dom": "^5.2.0",
    "redux-persist": "^6.0.0"
  },
  "scripts": {
    "dev": "vite",
    "start": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "test": "jest --env=jsdom",
    "test-ci": "CI=true jest --testPathIgnorePatterns=\"./test-e2e/\" --no-cache",
    "test-e2e": "jest test-e2e/*",
    "flow": "flow",
    "eslint": "eslint \"./src/**/*.js\"",
    "eslint-fix": "eslint . --fix"
  },
  "browserslist": [
    ">0.2%",
    "not dead",
    "not ie > 1",
    "not edge > 1",
    "not op_mini all"
  ],
  "resolutions": {
    "brace-expansion": "^2.1.4",
    "cheerio": "1.0.0-rc.12",
    "glob-parent": "^5.1.2",
    "immutable": "^5.1.8",
    "lodash": "^4.17.21",
    "nth-check": "^2.0.1",
    "path-parse": "^1.0.7",
    "tmpl": "^1.0.5"
  },
  "devDependencies": {
    "@babel/core": "^7.29.6",
    "@babel/eslint-parser": "7.29.9",
    "@babel/plugin-proposal-class-properties": "^7.18.6",
    "@babel/plugin-proposal-optional-chaining": "^7.21.0",
    "@babel/preset-env": "^7.29.6",
    "@babel/preset-flow": "^7.29.6",
    "@babel/preset-react": "^7.29.6",
    "@cfaester/enzyme-adapter-react-18": "0.7.1",
    "@vitejs/plugin-react": "6.1.1",
    "babel-plugin-dynamic-import-node": "^2.3.3",
    "enzyme": "^3.10.0",
    "enzyme-to-json": "^3.4.3",
    "eslint": "10.11.0",
    "eslint-config-prettier": "^8.8.0",
    "eslint-plugin-flow": "^2.29.1",
    "eslint-plugin-jest": "^27.2.1",
    "eslint-plugin-prettier": "^4.2.1",
    "flow-bin": "^0.207.0",
    "identity-obj-proxy": "^3.0.0",
    "jest": "30.5.2",
    "jest-environment-jsdom": "30.5.2",
    "jest-location-mock": "^4.0.1",
    "prettier": "^2.8.8",
    "sass": "1.104.1",
    "vite": "8.3.0",
    "vite-plugin-babel": "^1.7.3"
  }
}
